import React, { useState, useEffect, useRef, useCallback } from 'react';
import { NavigationDirection } from '../../hooks/useNavigation';
import './PageTransition.css';

interface PageTransitionProps {
  children: React.ReactNode;
  routeKey: string;
  direction: NavigationDirection;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children, routeKey, direction }) => {
  const [displayChildren, setDisplayChildren] = useState(children);
  const [animationClass, setAnimationClass] = useState('');
  const prevKeyRef = useRef(routeKey);
  const isAnimatingRef = useRef(false);

  const handleAnimationEnd = useCallback(() => {
    isAnimatingRef.current = false;
    setAnimationClass('');
  }, []);

  useEffect(() => {
    if (prevKeyRef.current === routeKey) {
      // Same route, just update content (e.g. props changed)
      setDisplayChildren(children);
      return;
    }

    prevKeyRef.current = routeKey;

    if (direction === 'none') {
      setDisplayChildren(children);
      return;
    }

    // Determine animation class based on direction
    const enterClass =
      direction === 'forward'
        ? 'page-slide-in-right'
        : 'page-slide-in-left';

    isAnimatingRef.current = true;
    setDisplayChildren(children);
    setAnimationClass(enterClass);
  }, [routeKey, children, direction]);

  return (
    <div
      className={`page-transition ${animationClass}`}
      onAnimationEnd={handleAnimationEnd}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition;
